import { Grid } from '@material-ui/core';
import React from 'react';

const PublicLayout = ({ children }) => {
  return (
    <Grid container>
      <Grid item xs={12}>
        {children}
      </Grid>
    </Grid>
  );
};

export default PublicLayout;
